var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['navbar-box flex-c-b', _vm.showHeader ? 'has-header' : 'no-header', _vm.mode]},[_c('div',{staticClass:"left-nav flex-c-s"},[_c('hamburger'),_c('breadcrumb')],1),(!_vm.showHeader)?_c('div',{staticClass:"right-nav"},[_c('right-nav')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }